import { DomUtils } from "../utils/domUtils";
import { BaseController } from "./base";

export const CompleteConstants = {
	backToLoginButton: "backToLoginButton",
	message: "message"
};

export class CompleteController extends BaseController {
	constructor() {
		super();

		this._message = null;
		this._email = null;
		this._returnUrl = null;
	}

	Init() {
		this._GetContextData();
		this._ShowMessage(this._message);
		this._BindEvents();

		this._SetupTimer();
	}

	_GetContextData() {
		this._message = window.message;
		this._email = window.email;
		this._returnUrl = window.returnUrl;
	}

	_ShowMessage(message) {
		this._localeService.SetElementTranslation(CompleteConstants.message, `oauth.${message}`);
	}

	_BindEvents() {
		const backToLoginButton = DomUtils.GetElement(CompleteConstants.backToLoginButton);
		backToLoginButton.addEventListener("click", this._OnLoginButtonClick.bind(this));
	}

	_OnLoginButtonClick() {
		window.location.href = this._returnUrl;
	}

	_SetupTimer() {
		setTimeout(() => {
			this._OnLoginButtonClick();
		}, 5000);
	}
}
